(function() {
    'use strict';

    angular
        .module('consinfApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VisioneConsensoDialogController', VisioneConsensoDialogController);

    VisioneConsensoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'VisioneConsenso', 'MessaggioVoucher', 'OggettoConsenso', 'ConsInfUser'];

    function VisioneConsensoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, VisioneConsenso, MessaggioVoucher, OggettoConsenso, ConsInfUser) {
        var vm = this;

        vm.visioneConsenso = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.messaggiovouchers = MessaggioVoucher.query();
        vm.oggettoconsensos = OggettoConsenso.query();
        vm.consinfusers = ConsInfUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.visioneConsenso.id !== null) {
                VisioneConsenso.update(vm.visioneConsenso, onSaveSuccess, onSaveError);
            } else {
                VisioneConsenso.save(vm.visioneConsenso, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:visioneConsensoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataVisione = false;

        vm.setFileFirma = function ($file, visioneConsenso) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        visioneConsenso.fileFirma = base64Data;
                        visioneConsenso.fileFirmaContentType = $file.type;
                    });
                });
            }
        };

        vm.setFileFotoCartaceo = function ($file, visioneConsenso) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        visioneConsenso.fileFotoCartaceo = base64Data;
                        visioneConsenso.fileFotoCartaceoContentType = $file.type;
                    });
                });
            }
        };

        vm.setFileVideoSelfie = function ($file, visioneConsenso) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        visioneConsenso.fileVideoSelfie = base64Data;
                        visioneConsenso.fileVideoSelfieContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VisioneConsensoDetailController', VisioneConsensoDetailController);

    VisioneConsensoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'VisioneConsenso', 'MessaggioVoucher', 'OggettoConsenso', 'ConsInfUser'];

    function VisioneConsensoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, VisioneConsenso, MessaggioVoucher, OggettoConsenso, ConsInfUser) {
        var vm = this;

        vm.visioneConsenso = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:visioneConsensoUpdate', function(event, result) {
            vm.visioneConsenso = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VisioneConsensoDeleteController',VisioneConsensoDeleteController);

    VisioneConsensoDeleteController.$inject = ['$uibModalInstance', 'entity', 'VisioneConsenso'];

    function VisioneConsensoDeleteController($uibModalInstance, entity, VisioneConsenso) {
        var vm = this;

        vm.visioneConsenso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VisioneConsenso.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('visione-consenso', {
            parent: 'entity',
            url: '/visione-consenso',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.visioneConsenso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visione-consenso/visione-consensos.html',
                    controller: 'VisioneConsensoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visioneConsenso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('visione-consenso-detail', {
            parent: 'visione-consenso',
            url: '/visione-consenso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.visioneConsenso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visione-consenso/visione-consenso-detail.html',
                    controller: 'VisioneConsensoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visioneConsenso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VisioneConsenso', function($stateParams, VisioneConsenso) {
                    return VisioneConsenso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'visione-consenso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('visione-consenso-detail.edit', {
            parent: 'visione-consenso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visione-consenso/visione-consenso-dialog.html',
                    controller: 'VisioneConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VisioneConsenso', function(VisioneConsenso) {
                            return VisioneConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visione-consenso.new', {
            parent: 'visione-consenso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visione-consenso/visione-consenso-dialog.html',
                    controller: 'VisioneConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paziente: null,
                                nome: null,
                                emailMedicoDiBase: null,
                                emailFamiliare: null,
                                dataVisione: null,
                                fileFirma: null,
                                fileFirmaContentType: null,
                                fileFotoCartaceo: null,
                                fileFotoCartaceoContentType: null,
                                fileVideoSelfie: null,
                                fileVideoSelfieContentType: null,
                                confermaHoCapito: null,
                                invioCedAttempts: null,
                                invioCedSuccess: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('visione-consenso', null, { reload: 'visione-consenso' });
                }, function() {
                    $state.go('visione-consenso');
                });
            }]
        })
        .state('visione-consenso.edit', {
            parent: 'visione-consenso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visione-consenso/visione-consenso-dialog.html',
                    controller: 'VisioneConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VisioneConsenso', function(VisioneConsenso) {
                            return VisioneConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visione-consenso', null, { reload: 'visione-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visione-consenso.delete', {
            parent: 'visione-consenso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visione-consenso/visione-consenso-delete-dialog.html',
                    controller: 'VisioneConsensoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VisioneConsenso', function(VisioneConsenso) {
                            return VisioneConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visione-consenso', null, { reload: 'visione-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('VisioneConsenso', VisioneConsenso);

    VisioneConsenso.$inject = ['$resource', 'DateUtils'];

    function VisioneConsenso ($resource, DateUtils) {
        var resourceUrl =  'api/visione-consensos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataVisione = DateUtils.convertDateTimeFromServer(data.dataVisione);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VisioneConsensoController', VisioneConsensoController);

    VisioneConsensoController.$inject = ['DataUtils', 'VisioneConsenso', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function VisioneConsensoController(DataUtils, VisioneConsenso, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.visioneConsensos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            VisioneConsenso.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.visioneConsensos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.visioneConsensos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDialogController', VideoInformativoDialogController);

    VideoInformativoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'VideoInformativo'];

    function VideoInformativoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.videoInformativo.id !== null) {
                VideoInformativo.update(vm.videoInformativo, onSaveSuccess, onSaveError);
            } else {
                VideoInformativo.save(vm.videoInformativo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:videoInformativoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validoDa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDetailController', VideoInformativoDetailController);

    VideoInformativoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'VideoInformativo'];

    function VideoInformativoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:videoInformativoUpdate', function(event, result) {
            vm.videoInformativo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDeleteController',VideoInformativoDeleteController);

    VideoInformativoDeleteController.$inject = ['$uibModalInstance', 'entity', 'VideoInformativo'];

    function VideoInformativoDeleteController($uibModalInstance, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VideoInformativo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video-informativo', {
            parent: 'entity',
            url: '/video-informativo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.videoInformativo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-informativo/video-informativos.html',
                    controller: 'VideoInformativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoInformativo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-informativo-detail', {
            parent: 'video-informativo',
            url: '/video-informativo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.videoInformativo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-informativo/video-informativo-detail.html',
                    controller: 'VideoInformativoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoInformativo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VideoInformativo', function($stateParams, VideoInformativo) {
                    return VideoInformativo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video-informativo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-informativo-detail.edit', {
            parent: 'video-informativo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-informativo.new', {
            parent: 'video-informativo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeProcedura: null,
                                versione: null,
                                nomeFile: null,
                                validoDa: null,
                                mimeType: null,
                                info: null,
                                note: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('video-informativo');
                });
            }]
        })
        .state('video-informativo.edit', {
            parent: 'video-informativo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-informativo.delete', {
            parent: 'video-informativo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-delete-dialog.html',
                    controller: 'VideoInformativoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('VideoInformativo', VideoInformativo);

    VideoInformativo.$inject = ['$resource', 'DateUtils'];

    function VideoInformativo ($resource, DateUtils) {
        var resourceUrl =  'api/video-informativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validoDa = DateUtils.convertDateTimeFromServer(data.validoDa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoController', VideoInformativoController);

    VideoInformativoController.$inject = ['DataUtils', 'VideoInformativo'];

    function VideoInformativoController(DataUtils, VideoInformativo) {

        var vm = this;

        vm.videoInformativos = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            VideoInformativo.query(function(result) {
                vm.videoInformativos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('OggettoConsensoDialogController', OggettoConsensoDialogController);

    OggettoConsensoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'OggettoConsenso', 'VisioneConsenso'];

    function OggettoConsensoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, OggettoConsenso, VisioneConsenso) {
        var vm = this;

        vm.oggettoConsenso = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.visioneconsensos = VisioneConsenso.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.oggettoConsenso.id !== null) {
                OggettoConsenso.update(vm.oggettoConsenso, onSaveSuccess, onSaveError);
            } else {
                OggettoConsenso.save(vm.oggettoConsenso, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:oggettoConsensoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setContenuto = function ($file, oggettoConsenso) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        oggettoConsenso.contenuto = base64Data;
                        oggettoConsenso.contenutoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('OggettoConsensoDetailController', OggettoConsensoDetailController);

    OggettoConsensoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'OggettoConsenso', 'VisioneConsenso'];

    function OggettoConsensoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, OggettoConsenso, VisioneConsenso) {
        var vm = this;

        vm.oggettoConsenso = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:oggettoConsensoUpdate', function(event, result) {
            vm.oggettoConsenso = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('OggettoConsensoDeleteController',OggettoConsensoDeleteController);

    OggettoConsensoDeleteController.$inject = ['$uibModalInstance', 'entity', 'OggettoConsenso'];

    function OggettoConsensoDeleteController($uibModalInstance, entity, OggettoConsenso) {
        var vm = this;

        vm.oggettoConsenso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OggettoConsenso.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('oggetto-consenso', {
            parent: 'entity',
            url: '/oggetto-consenso',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.oggettoConsenso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consensos.html',
                    controller: 'OggettoConsensoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('oggettoConsenso');
                    $translatePartialLoader.addPart('tipoOggettoConsenso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('oggetto-consenso-detail', {
            parent: 'oggetto-consenso',
            url: '/oggetto-consenso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.oggettoConsenso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-detail.html',
                    controller: 'OggettoConsensoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('oggettoConsenso');
                    $translatePartialLoader.addPart('tipoOggettoConsenso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OggettoConsenso', function($stateParams, OggettoConsenso) {
                    return OggettoConsenso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'oggetto-consenso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('oggetto-consenso-detail.edit', {
            parent: 'oggetto-consenso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('oggetto-consenso.new', {
            parent: 'oggetto-consenso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                codice: null,
                                info: null,
                                contenuto: null,
                                contenutoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('oggetto-consenso');
                });
            }]
        })
        .state('oggetto-consenso.edit', {
            parent: 'oggetto-consenso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('oggetto-consenso.delete', {
            parent: 'oggetto-consenso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-delete-dialog.html',
                    controller: 'OggettoConsensoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('OggettoConsenso', OggettoConsenso);

    OggettoConsenso.$inject = ['$resource'];

    function OggettoConsenso ($resource) {
        var resourceUrl =  'api/oggetto-consensos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('OggettoConsensoController', OggettoConsensoController);

    OggettoConsensoController.$inject = ['DataUtils', 'OggettoConsenso', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function OggettoConsensoController(DataUtils, OggettoConsenso, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.oggettoConsensos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            OggettoConsenso.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.oggettoConsensos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.oggettoConsensos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherDialogController', MessaggioVoucherDialogController);

    MessaggioVoucherDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MessaggioVoucher', 'VisioneConsenso'];

    function MessaggioVoucherDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MessaggioVoucher, VisioneConsenso) {
        var vm = this;

        vm.messaggioVoucher = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.visioneconsensos = VisioneConsenso.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.messaggioVoucher.id !== null) {
                MessaggioVoucher.update(vm.messaggioVoucher, onSaveSuccess, onSaveError);
            } else {
                MessaggioVoucher.save(vm.messaggioVoucher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:messaggioVoucherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.requestDate = false;
        vm.datePickerOpenStatus.sendDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherDetailController', MessaggioVoucherDetailController);

    MessaggioVoucherDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MessaggioVoucher', 'VisioneConsenso'];

    function MessaggioVoucherDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MessaggioVoucher, VisioneConsenso) {
        var vm = this;

        vm.messaggioVoucher = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:messaggioVoucherUpdate', function(event, result) {
            vm.messaggioVoucher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherDeleteController',MessaggioVoucherDeleteController);

    MessaggioVoucherDeleteController.$inject = ['$uibModalInstance', 'entity', 'MessaggioVoucher'];

    function MessaggioVoucherDeleteController($uibModalInstance, entity, MessaggioVoucher) {
        var vm = this;

        vm.messaggioVoucher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MessaggioVoucher.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('messaggio-voucher', {
            parent: 'entity',
            url: '/messaggio-voucher',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.messaggioVoucher.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-vouchers.html',
                    controller: 'MessaggioVoucherController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messaggioVoucher');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('messaggio-voucher-detail', {
            parent: 'messaggio-voucher',
            url: '/messaggio-voucher/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.messaggioVoucher.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-detail.html',
                    controller: 'MessaggioVoucherDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messaggioVoucher');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MessaggioVoucher', function($stateParams, MessaggioVoucher) {
                    return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'messaggio-voucher',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('messaggio-voucher-detail.edit', {
            parent: 'messaggio-voucher-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('messaggio-voucher.new', {
            parent: 'messaggio-voucher',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                senderEmail: null,
                                recipientEmail: null,
                                ccEmail: null,
                                voucherCode: null,
                                subject: null,
                                body: null,
                                requestDate: null,
                                sendDate: null,
                                attempts: null,
                                success: null,
                                agreed: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('messaggio-voucher');
                });
            }]
        })
        .state('messaggio-voucher.edit', {
            parent: 'messaggio-voucher',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('messaggio-voucher.delete', {
            parent: 'messaggio-voucher',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-delete-dialog.html',
                    controller: 'MessaggioVoucherDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('MessaggioVoucher', MessaggioVoucher);

    MessaggioVoucher.$inject = ['$resource', 'DateUtils'];

    function MessaggioVoucher ($resource, DateUtils) {
        var resourceUrl =  'api/messaggio-vouchers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requestDate = DateUtils.convertDateTimeFromServer(data.requestDate);
                        data.sendDate = DateUtils.convertDateTimeFromServer(data.sendDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherController', MessaggioVoucherController);

    MessaggioVoucherController.$inject = ['DataUtils', 'MessaggioVoucher', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MessaggioVoucherController(DataUtils, MessaggioVoucher, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.messaggioVouchers = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            MessaggioVoucher.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.messaggioVouchers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.messaggioVouchers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserDialogController', ConsInfUserDialogController);

    ConsInfUserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'ConsInfUser', 'User', 'VisioneConsenso', 'ConsInfAccount'];

    function ConsInfUserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, ConsInfUser, User, VisioneConsenso, ConsInfAccount) {
        var vm = this;

        vm.consInfUser = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();
        vm.visioneconsensos = VisioneConsenso.query();
        vm.consinfaccounts = ConsInfAccount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.consInfUser.id !== null) {
                ConsInfUser.update(vm.consInfUser, onSaveSuccess, onSaveError);
            } else {
                ConsInfUser.save(vm.consInfUser, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:consInfUserUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserDetailController', ConsInfUserDetailController);

    ConsInfUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ConsInfUser', 'User', 'VisioneConsenso', 'ConsInfAccount'];

    function ConsInfUserDetailController($scope, $rootScope, $stateParams, previousState, entity, ConsInfUser, User, VisioneConsenso, ConsInfAccount) {
        var vm = this;

        vm.consInfUser = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consinfApp:consInfUserUpdate', function(event, result) {
            vm.consInfUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserDeleteController',ConsInfUserDeleteController);

    ConsInfUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConsInfUser'];

    function ConsInfUserDeleteController($uibModalInstance, entity, ConsInfUser) {
        var vm = this;

        vm.consInfUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ConsInfUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cons-inf-user', {
            parent: 'entity',
            url: '/cons-inf-user',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-users.html',
                    controller: 'ConsInfUserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cons-inf-user-detail', {
            parent: 'cons-inf-user',
            url: '/cons-inf-user/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-detail.html',
                    controller: 'ConsInfUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfUser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConsInfUser', function($stateParams, ConsInfUser) {
                    return ConsInfUser.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cons-inf-user',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cons-inf-user-detail.edit', {
            parent: 'cons-inf-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-user.new', {
            parent: 'cons-inf-user',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                longName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('cons-inf-user');
                });
            }]
        })
        .state('cons-inf-user.edit', {
            parent: 'cons-inf-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-user.delete', {
            parent: 'cons-inf-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-delete-dialog.html',
                    controller: 'ConsInfUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('ConsInfUser', ConsInfUser);

    ConsInfUser.$inject = ['$resource'];

    function ConsInfUser ($resource) {
        var resourceUrl =  'api/cons-inf-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserController', ConsInfUserController);

    ConsInfUserController.$inject = ['ConsInfUser', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ConsInfUserController(ConsInfUser, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.consInfUsers = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            ConsInfUser.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.consInfUsers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.consInfUsers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfAccountDialogController', ConsInfAccountDialogController);

    ConsInfAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ConsInfAccount', 'ConsInfUser'];

    function ConsInfAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ConsInfAccount, ConsInfUser) {
        var vm = this;

        vm.consInfAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.consinfusers = ConsInfUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.consInfAccount.id !== null) {
                ConsInfAccount.update(vm.consInfAccount, onSaveSuccess, onSaveError);
            } else {
                ConsInfAccount.save(vm.consInfAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:consInfAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.renewalDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfAccountDetailController', ConsInfAccountDetailController);

    ConsInfAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ConsInfAccount', 'ConsInfUser'];

    function ConsInfAccountDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ConsInfAccount, ConsInfUser) {
        var vm = this;

        vm.consInfAccount = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consinfApp:consInfAccountUpdate', function(event, result) {
            vm.consInfAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfAccountDeleteController',ConsInfAccountDeleteController);

    ConsInfAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConsInfAccount'];

    function ConsInfAccountDeleteController($uibModalInstance, entity, ConsInfAccount) {
        var vm = this;

        vm.consInfAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ConsInfAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cons-inf-account', {
            parent: 'entity',
            url: '/cons-inf-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-accounts.html',
                    controller: 'ConsInfAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfAccount');
                    $translatePartialLoader.addPart('tipoInvio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cons-inf-account-detail', {
            parent: 'cons-inf-account',
            url: '/cons-inf-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-detail.html',
                    controller: 'ConsInfAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfAccount');
                    $translatePartialLoader.addPart('tipoInvio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConsInfAccount', function($stateParams, ConsInfAccount) {
                    return ConsInfAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cons-inf-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cons-inf-account-detail.edit', {
            parent: 'cons-inf-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-account.new', {
            parent: 'cons-inf-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                address: null,
                                email: null,
                                legalEmail: null,
                                asciiArmor: null,
                                phoneNumber: null,
                                country: null,
                                vat: null,
                                creationDate: null,
                                renewalDate: null,
                                tipoInvio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('cons-inf-account');
                });
            }]
        })
        .state('cons-inf-account.edit', {
            parent: 'cons-inf-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-account.delete', {
            parent: 'cons-inf-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-delete-dialog.html',
                    controller: 'ConsInfAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('ConsInfAccount', ConsInfAccount);

    ConsInfAccount.$inject = ['$resource', 'DateUtils'];

    function ConsInfAccount ($resource, DateUtils) {
        var resourceUrl =  'api/cons-inf-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.renewalDate = DateUtils.convertLocalDateFromServer(data.renewalDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.renewalDate = DateUtils.convertLocalDateToServer(copy.renewalDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.renewalDate = DateUtils.convertLocalDateToServer(copy.renewalDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfAccountController', ConsInfAccountController);

    ConsInfAccountController.$inject = ['DataUtils', 'ConsInfAccount', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ConsInfAccountController(DataUtils, ConsInfAccount, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.consInfAccounts = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            ConsInfAccount.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.consInfAccounts.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.consInfAccounts = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('consinfApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('consinfApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('consinfApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('consinfApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('consinfApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('consinfApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('consinfApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('consinfApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('consinfApp')
        .constant('VERSION', "1.0.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CONSINF_PROPOSER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('consinfApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('consinfApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('consinfApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a> but you don\'t have the credentials, please contact the system administrator.</div><!--\n                <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>\n                    You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a>\n                </div>\n--></div><!--\n            <p data-translate="home.question">\n                If you have any question on JHipster:\n            </p>\n\n            <ul>\n                <li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li>\n                <li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li>\n                <li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li>\n                <li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li>\n                <li><a href="https://twitter.com/java_hipster" target="_blank"  data-translate="home.link.follow">follow @java_hipster on Twitter</a></li>\n            </ul>\n\n            <p>\n             <span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!\n            </p>\n--></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a> use your account or contact the system administrator to get a new one.</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.password">Password</label><input type="password" class="form-control" name="password" ng-model="vm.user.password" ng-maxlength="50"><div ng-show="editForm.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><!--\n            <div class="alert alert-warning">\n                <a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a>\n            </div>\n            <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div>\n            --></div></div></div>');
$templateCache.put('app/entities/cons-inf-account/cons-inf-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.consInfAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.consInfAccount.delete.question" translate-values="{id: \'{{vm.consInfAccount.id}}\'}">Are you sure you want to delete this Cons Inf Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cons-inf-account/cons-inf-account-detail.html','<div><h2><span data-translate="consinfApp.consInfAccount.detail.title">Cons Inf Account</span> {{vm.consInfAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.consInfAccount.name">Name</span></dt><dd><span>{{vm.consInfAccount.name}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.address">Address</span></dt><dd><span>{{vm.consInfAccount.address}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.email">Email</span></dt><dd><span>{{vm.consInfAccount.email}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.legalEmail">Legal Email</span></dt><dd><span>{{vm.consInfAccount.legalEmail}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.asciiArmor">Ascii Armor</span></dt><dd><span>{{vm.consInfAccount.asciiArmor}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.phoneNumber">Phone Number</span></dt><dd><span>{{vm.consInfAccount.phoneNumber}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.country">Country</span></dt><dd><span>{{vm.consInfAccount.country}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.vat">Vat</span></dt><dd><span>{{vm.consInfAccount.vat}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.creationDate">Creation Date</span></dt><dd><span>{{vm.consInfAccount.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.renewalDate">Renewal Date</span></dt><dd><span>{{vm.consInfAccount.renewalDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="consinfApp.consInfAccount.tipoInvio">Tipo Invio</span></dt><dd><span data-translate="{{\'consinfApp.TipoInvio.\' + vm.consInfAccount.tipoInvio}}">{{vm.consInfAccount.tipoInvio}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cons-inf-account-detail.edit({id:vm.consInfAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cons-inf-account/cons-inf-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConsInfAccountLabel" data-translate="consinfApp.consInfAccount.home.createOrEditLabel">Create or edit a Cons Inf Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.consInfAccount.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.consInfAccount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.consInfAccount.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.consInfAccount.address"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.consInfAccount.email"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.legalEmail" for="field_legalEmail">Legal Email</label><input type="text" class="form-control" name="legalEmail" id="field_legalEmail" ng-model="vm.consInfAccount.legalEmail"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.asciiArmor" for="field_asciiArmor">Ascii Armor</label><textarea class="form-control" name="asciiArmor" id="field_asciiArmor" ng-model="vm.consInfAccount.asciiArmor"></textarea></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.phoneNumber" for="field_phoneNumber">Phone Number</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.consInfAccount.phoneNumber"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.country" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.consInfAccount.country"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.vat" for="field_vat">Vat</label><input type="text" class="form-control" name="vat" id="field_vat" ng-model="vm.consInfAccount.vat"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.consInfAccount.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.renewalDate" for="field_renewalDate">Renewal Date</label><div class="input-group"><input id="field_renewalDate" type="text" class="form-control" name="renewalDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.consInfAccount.renewalDate" is-open="vm.datePickerOpenStatus.renewalDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'renewalDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfAccount.tipoInvio" for="field_tipoInvio">Tipo Invio</label><select class="form-control" name="tipoInvio" ng-model="vm.consInfAccount.tipoInvio" id="field_tipoInvio" required><option value="PEC" data-translate="consinfApp.TipoInvio.PEC">PEC</option></select><div ng-show="editForm.tipoInvio.$invalid"><p class="help-block" ng-show="editForm.tipoInvio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cons-inf-account/cons-inf-accounts.html','<div><h2 data-translate="consinfApp.consInfAccount.home.title">Cons Inf Accounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cons-inf-account.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.consInfAccount.home.createLabel">Create new Cons Inf Account</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="consinfApp.consInfAccount.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="address"><span data-translate="consinfApp.consInfAccount.address">Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="consinfApp.consInfAccount.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="legalEmail"><span data-translate="consinfApp.consInfAccount.legalEmail">Legal Email</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="asciiArmor"><span data-translate="consinfApp.consInfAccount.asciiArmor">Ascii Armor</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="phoneNumber"><span data-translate="consinfApp.consInfAccount.phoneNumber">Phone Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country"><span data-translate="consinfApp.consInfAccount.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vat"><span data-translate="consinfApp.consInfAccount.vat">Vat</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationDate"><span data-translate="consinfApp.consInfAccount.creationDate">Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="renewalDate"><span data-translate="consinfApp.consInfAccount.renewalDate">Renewal Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoInvio"><span data-translate="consinfApp.consInfAccount.tipoInvio">Tipo Invio</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="consInfAccount in vm.consInfAccounts track by consInfAccount.id"><td><a ui-sref="cons-inf-account-detail({id:consInfAccount.id})">{{consInfAccount.id}}</a></td><td>{{consInfAccount.name}}</td><td>{{consInfAccount.address}}</td><td>{{consInfAccount.email}}</td><td>{{consInfAccount.legalEmail}}</td><!--<td>{{consInfAccount.asciiArmor}}</td>--><td>{{consInfAccount.phoneNumber}}</td><td>{{consInfAccount.country}}</td><td>{{consInfAccount.vat}}</td><td>{{consInfAccount.creationDate | date:\'medium\'}}</td><td>{{consInfAccount.renewalDate | date:\'mediumDate\'}}</td><td data-translate="{{\'consinfApp.TipoInvio.\' + consInfAccount.tipoInvio}}">{{consInfAccount.tipoInvio}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cons-inf-account-detail({id:consInfAccount.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cons-inf-account.edit({id:consInfAccount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cons-inf-account.delete({id:consInfAccount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cons-inf-user/cons-inf-user-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.consInfUser.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.consInfUser.delete.question" translate-values="{id: \'{{vm.consInfUser.id}}\'}">Are you sure you want to delete this Cons Inf User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cons-inf-user/cons-inf-user-detail.html','<div><h2><span data-translate="consinfApp.consInfUser.detail.title">Cons Inf User</span> {{vm.consInfUser.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.consInfUser.active">Active</span></dt><dd><span>{{vm.consInfUser.active}}</span></dd><dt><span data-translate="consinfApp.consInfUser.longName">Long Name</span></dt><dd><span>{{vm.consInfUser.longName}}</span></dd><dt><span data-translate="consinfApp.consInfUser.user">User</span></dt><dd>{{vm.consInfUser.user.id}} - {{vm.consInfUser.user.login}}</dd><dt><span data-translate="consinfApp.consInfUser.consInfAccount">Cons Inf Account</span></dt><dd><a ui-sref="cons-inf-account-detail({id:vm.consInfUser.consInfAccount.id})">{{vm.consInfUser.consInfAccount.id}} - {{vm.consInfUser.consInfAccount.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cons-inf-user-detail.edit({id:vm.consInfUser.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cons-inf-user/cons-inf-user-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConsInfUserLabel" data-translate="consinfApp.consInfUser.home.createOrEditLabel">Create or edit a Cons Inf User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.consInfUser.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.consInfUser.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfUser.active" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.consInfUser.active"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.consInfUser.longName" for="field_longName">Long Name</label><input type="text" class="form-control" name="longName" id="field_longName" ng-model="vm.consInfUser.longName" required><div ng-show="editForm.longName.$invalid"><p class="help-block" ng-show="editForm.longName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="consinfApp.consInfUser.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.consInfUser.user" ng-options="user as user.id for user in vm.users track by user.id"><option value=""></option></select></div><div class="form-group"><label data-translate="consinfApp.consInfUser.consInfAccount" for="field_consInfAccount">Cons Inf Account</label><select class="form-control" id="field_consInfAccount" name="consInfAccount" ng-model="vm.consInfUser.consInfAccount" ng-options="consInfAccount as consInfAccount.id for consInfAccount in vm.consinfaccounts track by consInfAccount.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cons-inf-user/cons-inf-users.html','<div><h2 data-translate="consinfApp.consInfUser.home.title">Cons Inf Users</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cons-inf-user.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.consInfUser.home.createLabel">Create new Cons Inf User</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="consinfApp.consInfUser.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longName"><span data-translate="consinfApp.consInfUser.longName">Long Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.id"><span data-translate="consinfApp.consInfUser.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="consInfAccount.id"><span data-translate="consinfApp.consInfUser.consInfAccount">Cons Inf Account</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="consInfUser in vm.consInfUsers track by consInfUser.id"><td><a ui-sref="cons-inf-user-detail({id:consInfUser.id})">{{consInfUser.id}}</a></td><td>{{consInfUser.active}}</td><td>{{consInfUser.longName}}</td><td>{{consInfUser.user.id}}</td><td><a ui-sref="cons-inf-account-detail({id:consInfUser.consInfAccount.id})">{{consInfUser.consInfAccount.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cons-inf-user-detail({id:consInfUser.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cons-inf-user.edit({id:consInfUser.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cons-inf-user.delete({id:consInfUser.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/messaggio-voucher/messaggio-voucher-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.messaggioVoucher.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.messaggioVoucher.delete.question" translate-values="{id: \'{{vm.messaggioVoucher.id}}\'}">Are you sure you want to delete this Messaggio Voucher?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/messaggio-voucher/messaggio-voucher-detail.html','<div><h2><span data-translate="consinfApp.messaggioVoucher.detail.title">Messaggio Voucher</span> {{vm.messaggioVoucher.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.messaggioVoucher.senderEmail">Sender Email</span></dt><dd><span>{{vm.messaggioVoucher.senderEmail}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.recipientEmail">Recipient Email</span></dt><dd><span>{{vm.messaggioVoucher.recipientEmail}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.ccEmail">Cc Email</span></dt><dd><span>{{vm.messaggioVoucher.ccEmail}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.voucherCode">Voucher Code</span></dt><dd><span>{{vm.messaggioVoucher.voucherCode}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.subject">Subject</span></dt><dd><span>{{vm.messaggioVoucher.subject}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.body">Body</span></dt><dd><span>{{vm.messaggioVoucher.body}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.requestDate">Request Date</span></dt><dd><span>{{vm.messaggioVoucher.requestDate | date:\'medium\'}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.sendDate">Send Date</span></dt><dd><span>{{vm.messaggioVoucher.sendDate | date:\'medium\'}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.attempts">Attempts</span></dt><dd><span>{{vm.messaggioVoucher.attempts}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.success">Success</span></dt><dd><span>{{vm.messaggioVoucher.success}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.agreed">Agreed</span></dt><dd><span>{{vm.messaggioVoucher.agreed}}</span></dd><dt><span data-translate="consinfApp.messaggioVoucher.visioneConsenso">Visione Consenso</span></dt><dd><a ui-sref="visione-consenso-detail({id:vm.messaggioVoucher.visioneConsenso.id})">{{vm.messaggioVoucher.visioneConsenso.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="messaggio-voucher-detail.edit({id:vm.messaggioVoucher.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/messaggio-voucher/messaggio-voucher-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMessaggioVoucherLabel" data-translate="consinfApp.messaggioVoucher.home.createOrEditLabel">Create or edit a Messaggio Voucher</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.messaggioVoucher.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.messaggioVoucher.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.senderEmail" for="field_senderEmail">Sender Email</label><input type="text" class="form-control" name="senderEmail" id="field_senderEmail" ng-model="vm.messaggioVoucher.senderEmail"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.recipientEmail" for="field_recipientEmail">Recipient Email</label><input type="text" class="form-control" name="recipientEmail" id="field_recipientEmail" ng-model="vm.messaggioVoucher.recipientEmail"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.ccEmail" for="field_ccEmail">Cc Email</label><input type="text" class="form-control" name="ccEmail" id="field_ccEmail" ng-model="vm.messaggioVoucher.ccEmail"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.voucherCode" for="field_voucherCode">Voucher Code</label><textarea class="form-control" name="voucherCode" id="field_voucherCode" ng-model="vm.messaggioVoucher.voucherCode"></textarea></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.subject" for="field_subject">Subject</label><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.messaggioVoucher.subject"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.body" for="field_body">Body</label><textarea class="form-control" name="body" id="field_body" ng-model="vm.messaggioVoucher.body"></textarea></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.requestDate" for="field_requestDate">Request Date</label><div class="input-group"><input id="field_requestDate" type="text" class="form-control" name="requestDate" datetime-picker="{{dateformat}}" ng-model="vm.messaggioVoucher.requestDate" is-open="vm.datePickerOpenStatus.requestDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'requestDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.sendDate" for="field_sendDate">Send Date</label><div class="input-group"><input id="field_sendDate" type="text" class="form-control" name="sendDate" datetime-picker="{{dateformat}}" ng-model="vm.messaggioVoucher.sendDate" is-open="vm.datePickerOpenStatus.sendDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sendDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.attempts" for="field_attempts">Attempts</label><input type="number" class="form-control" name="attempts" id="field_attempts" ng-model="vm.messaggioVoucher.attempts"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.success" for="field_success">Success</label><input type="checkbox" name="success" id="field_success" ng-model="vm.messaggioVoucher.success"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.messaggioVoucher.agreed" for="field_agreed">Agreed</label><input type="checkbox" name="agreed" id="field_agreed" ng-model="vm.messaggioVoucher.agreed"></div><div class="form-group"><label data-translate="consinfApp.messaggioVoucher.visioneConsenso" for="field_visioneConsenso">Visione Consenso</label><select class="form-control" id="field_visioneConsenso" name="visioneConsenso" ng-model="vm.messaggioVoucher.visioneConsenso" ng-options="visioneConsenso as visioneConsenso.id for visioneConsenso in vm.visioneconsensos track by visioneConsenso.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/messaggio-voucher/messaggio-vouchers.html','<div><h2 data-translate="consinfApp.messaggioVoucher.home.title">Messaggio Vouchers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="messaggio-voucher.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.messaggioVoucher.home.createLabel">Create new Messaggio Voucher</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="senderEmail"><span data-translate="consinfApp.messaggioVoucher.senderEmail">Sender Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recipientEmail"><span data-translate="consinfApp.messaggioVoucher.recipientEmail">Recipient Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ccEmail"><span data-translate="consinfApp.messaggioVoucher.ccEmail">Cc Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="voucherCode"><span data-translate="consinfApp.messaggioVoucher.voucherCode">Voucher Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subject"><span data-translate="consinfApp.messaggioVoucher.subject">Subject</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="body"><span data-translate="consinfApp.messaggioVoucher.body">Body</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="requestDate"><span data-translate="consinfApp.messaggioVoucher.requestDate">Request Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sendDate"><span data-translate="consinfApp.messaggioVoucher.sendDate">Send Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="attempts"><span data-translate="consinfApp.messaggioVoucher.attempts">Attempts</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="success"><span data-translate="consinfApp.messaggioVoucher.success">Success</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agreed"><span data-translate="consinfApp.messaggioVoucher.agreed">Agreed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visioneConsenso.id"><span data-translate="consinfApp.messaggioVoucher.visioneConsenso">Visione Consenso</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="messaggioVoucher in vm.messaggioVouchers track by messaggioVoucher.id"><td><a ui-sref="messaggio-voucher-detail({id:messaggioVoucher.id})">{{messaggioVoucher.id}}</a></td><td>{{messaggioVoucher.senderEmail}}</td><td>{{messaggioVoucher.recipientEmail}}</td><td>{{messaggioVoucher.ccEmail}}</td><td>{{messaggioVoucher.voucherCode}}</td><td>{{messaggioVoucher.subject}}</td><td>{{messaggioVoucher.body}}</td><td>{{messaggioVoucher.requestDate | date:\'medium\'}}</td><td>{{messaggioVoucher.sendDate | date:\'medium\'}}</td><td>{{messaggioVoucher.attempts}}</td><td>{{messaggioVoucher.success}}</td><td>{{messaggioVoucher.agreed}}</td><td><a ui-sref="visione-consenso-detail({id:messaggioVoucher.visioneConsenso.id})">{{messaggioVoucher.visioneConsenso.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="messaggio-voucher-detail({id:messaggioVoucher.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="messaggio-voucher.edit({id:messaggioVoucher.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="messaggio-voucher.delete({id:messaggioVoucher.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/oggetto-consenso/oggetto-consenso-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.oggettoConsenso.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.oggettoConsenso.delete.question" translate-values="{id: \'{{vm.oggettoConsenso.id}}\'}">Are you sure you want to delete this Oggetto Consenso?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/oggetto-consenso/oggetto-consenso-detail.html','<div><h2><span data-translate="consinfApp.oggettoConsenso.detail.title">Oggetto Consenso</span> {{vm.oggettoConsenso.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.oggettoConsenso.tipo">Tipo</span></dt><dd><span data-translate="{{\'consinfApp.TipoOggettoConsenso.\' + vm.oggettoConsenso.tipo}}">{{vm.oggettoConsenso.tipo}}</span></dd><dt><span data-translate="consinfApp.oggettoConsenso.codice">Codice</span></dt><dd><span>{{vm.oggettoConsenso.codice}}</span></dd><dt><span data-translate="consinfApp.oggettoConsenso.info">Info</span></dt><dd><span>{{vm.oggettoConsenso.info}}</span></dd><dt><span data-translate="consinfApp.oggettoConsenso.contenuto">Contenuto</span></dt><dd><div ng-if="vm.oggettoConsenso.contenuto"><a ng-click="vm.openFile(vm.oggettoConsenso.contenutoContentType, vm.oggettoConsenso.contenuto)" data-translate="entity.action.open">open</a> {{vm.oggettoConsenso.contenutoContentType}}, {{vm.byteSize(vm.oggettoConsenso.contenuto)}}</div></dd><dt><span data-translate="consinfApp.oggettoConsenso.visioneConsenso">Visione Consenso</span></dt><dd><a ui-sref="visione-consenso-detail({id:vm.oggettoConsenso.visioneConsenso.id})">{{vm.oggettoConsenso.visioneConsenso.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="oggetto-consenso-detail.edit({id:vm.oggettoConsenso.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/oggetto-consenso/oggetto-consenso-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOggettoConsensoLabel" data-translate="consinfApp.oggettoConsenso.home.createOrEditLabel">Create or edit a Oggetto Consenso</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.oggettoConsenso.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.oggettoConsenso.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.oggettoConsenso.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.oggettoConsenso.tipo" id="field_tipo" required><option value="VIDEO" data-translate="consinfApp.TipoOggettoConsenso.VIDEO">VIDEO</option></select><div ng-show="editForm.tipo.$invalid"><p class="help-block" ng-show="editForm.tipo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.oggettoConsenso.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.oggettoConsenso.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.oggettoConsenso.info" for="field_info">Info</label><input type="text" class="form-control" name="info" id="field_info" ng-model="vm.oggettoConsenso.info"></div><div class="form-group" ngf-drop ngf-change="vm.setContenuto($file, vm.oggettoConsenso)"><label class="control-label" data-translate="consinfApp.oggettoConsenso.contenuto" for="field_contenuto">Contenuto</label><div><div ng-if="vm.oggettoConsenso.contenuto" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.oggettoConsenso.contenutoContentType, vm.oggettoConsenso.contenuto)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.oggettoConsenso.contenutoContentType}}, {{vm.byteSize(vm.oggettoConsenso.contenuto)}}</span> <button type="button" ng-click="vm.oggettoConsenso.contenuto=null;vm.oggettoConsenso.contenutoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setContenuto($file, vm.oggettoConsenso)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="contenuto" id="field_contenuto" ng-model="vm.oggettoConsenso.contenuto"> <input type="hidden" class="form-control" name="contenutoContentType" id="field_contenutoContentType" ng-model="vm.oggettoConsenso.contenutoContentType"></div><div class="form-group"><label data-translate="consinfApp.oggettoConsenso.visioneConsenso" for="field_visioneConsenso">Visione Consenso</label><select class="form-control" id="field_visioneConsenso" name="visioneConsenso" ng-model="vm.oggettoConsenso.visioneConsenso" ng-options="visioneConsenso as visioneConsenso.id for visioneConsenso in vm.visioneconsensos track by visioneConsenso.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/oggetto-consenso/oggetto-consensos.html','<div><h2 data-translate="consinfApp.oggettoConsenso.home.title">Oggetto Consensos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="oggetto-consenso.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.oggettoConsenso.home.createLabel">Create new Oggetto Consenso</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipo"><span data-translate="consinfApp.oggettoConsenso.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codice"><span data-translate="consinfApp.oggettoConsenso.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="info"><span data-translate="consinfApp.oggettoConsenso.info">Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contenuto"><span data-translate="consinfApp.oggettoConsenso.contenuto">Contenuto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visioneConsenso.id"><span data-translate="consinfApp.oggettoConsenso.visioneConsenso">Visione Consenso</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="oggettoConsenso in vm.oggettoConsensos track by oggettoConsenso.id"><td><a ui-sref="oggetto-consenso-detail({id:oggettoConsenso.id})">{{oggettoConsenso.id}}</a></td><td data-translate="{{\'consinfApp.TipoOggettoConsenso.\' + oggettoConsenso.tipo}}">{{oggettoConsenso.tipo}}</td><td>{{oggettoConsenso.codice}}</td><td>{{oggettoConsenso.info}}</td><td><a ng-if="oggettoConsenso.contenuto" ng-click="vm.openFile(oggettoConsenso.contenutoContentType, oggettoConsenso.contenuto)" data-translate="entity.action.open">open</a> <span ng-if="oggettoConsenso.contenuto">{{oggettoConsenso.contenutoContentType}}, {{vm.byteSize(oggettoConsenso.contenuto)}}</span></td><td><a ui-sref="visione-consenso-detail({id:oggettoConsenso.visioneConsenso.id})">{{oggettoConsenso.visioneConsenso.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="oggetto-consenso-detail({id:oggettoConsenso.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="oggetto-consenso.edit({id:oggettoConsenso.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="oggetto-consenso.delete({id:oggettoConsenso.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/video-informativo/video-informativo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.videoInformativo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.videoInformativo.delete.question" translate-values="{id: \'{{vm.videoInformativo.id}}\'}">Are you sure you want to delete this Video Informativo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/video-informativo/video-informativo-detail.html','<div><h2><span data-translate="consinfApp.videoInformativo.detail.title">Video Informativo</span> {{vm.videoInformativo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.videoInformativo.nomeProcedura">Nome Procedura</span></dt><dd><span>{{vm.videoInformativo.nomeProcedura}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.versione">Versione</span></dt><dd><span>{{vm.videoInformativo.versione}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.nomeFile">Nome File</span></dt><dd><span>{{vm.videoInformativo.nomeFile}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.validoDa">Valido Da</span></dt><dd><span>{{vm.videoInformativo.validoDa | date:\'medium\'}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.mimeType">Mime Type</span></dt><dd><span>{{vm.videoInformativo.mimeType}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.info">Info</span></dt><dd><span>{{vm.videoInformativo.info}}</span></dd><dt><span data-translate="consinfApp.videoInformativo.note">Note</span></dt><dd><span>{{vm.videoInformativo.note}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="video-informativo-detail.edit({id:vm.videoInformativo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/video-informativo/video-informativo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoInformativoLabel" data-translate="consinfApp.videoInformativo.home.createOrEditLabel">Create or edit a Video Informativo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.videoInformativo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.videoInformativo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.nomeProcedura" for="field_nomeProcedura">Nome Procedura</label><input type="text" class="form-control" name="nomeProcedura" id="field_nomeProcedura" ng-model="vm.videoInformativo.nomeProcedura"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.versione" for="field_versione">Versione</label><input type="text" class="form-control" name="versione" id="field_versione" ng-model="vm.videoInformativo.versione"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.nomeFile" for="field_nomeFile">Nome File</label><input type="text" class="form-control" name="nomeFile" id="field_nomeFile" ng-model="vm.videoInformativo.nomeFile"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.validoDa" for="field_validoDa">Valido Da</label><div class="input-group"><input id="field_validoDa" type="text" class="form-control" name="validoDa" datetime-picker="{{dateformat}}" ng-model="vm.videoInformativo.validoDa" is-open="vm.datePickerOpenStatus.validoDa"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validoDa\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.mimeType" for="field_mimeType">Mime Type</label><input type="text" class="form-control" name="mimeType" id="field_mimeType" ng-model="vm.videoInformativo.mimeType"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.info" for="field_info">Info</label><textarea class="form-control" name="info" id="field_info" ng-model="vm.videoInformativo.info"></textarea></div><div class="form-group"><label class="control-label" data-translate="consinfApp.videoInformativo.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.videoInformativo.note"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/video-informativo/video-informativos.html','<div><h2 data-translate="consinfApp.videoInformativo.home.title">Video Informativos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="video-informativo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.videoInformativo.home.createLabel">Create new Video Informativo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="consinfApp.videoInformativo.nomeProcedura">Nome Procedura</span></th><th><span data-translate="consinfApp.videoInformativo.versione">Versione</span></th><th><span data-translate="consinfApp.videoInformativo.nomeFile">Nome File</span></th><th><span data-translate="consinfApp.videoInformativo.validoDa">Valido Da</span></th><th><span data-translate="consinfApp.videoInformativo.mimeType">Mime Type</span></th><th><span data-translate="consinfApp.videoInformativo.info">Info</span></th><th><span data-translate="consinfApp.videoInformativo.note">Note</span></th><th></th></tr></thead><tbody><tr ng-repeat="videoInformativo in vm.videoInformativos track by videoInformativo.id"><td><a ui-sref="video-informativo-detail({id:videoInformativo.id})">{{videoInformativo.id}}</a></td><td>{{videoInformativo.nomeProcedura}}</td><td>{{videoInformativo.versione}}</td><td>{{videoInformativo.nomeFile}}</td><td>{{videoInformativo.validoDa | date:\'medium\'}}</td><td>{{videoInformativo.mimeType}}</td><td>{{videoInformativo.info}}</td><td>{{videoInformativo.note}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="video-informativo-detail({id:videoInformativo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="video-informativo.edit({id:videoInformativo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="video-informativo.delete({id:videoInformativo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/visione-consenso/visione-consenso-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.visioneConsenso.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consinfApp.visioneConsenso.delete.question" translate-values="{id: \'{{vm.visioneConsenso.id}}\'}">Are you sure you want to delete this Visione Consenso?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/visione-consenso/visione-consenso-detail.html','<div><h2><span data-translate="consinfApp.visioneConsenso.detail.title">Visione Consenso</span> {{vm.visioneConsenso.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consinfApp.visioneConsenso.paziente">Paziente</span></dt><dd><span>{{vm.visioneConsenso.paziente}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.nome">Nome</span></dt><dd><span>{{vm.visioneConsenso.nome}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.emailMedicoDiBase">Email Medico Di Base</span></dt><dd><span>{{vm.visioneConsenso.emailMedicoDiBase}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.emailFamiliare">Email Familiare</span></dt><dd><span>{{vm.visioneConsenso.emailFamiliare}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.dataVisione">Data Visione</span></dt><dd><span>{{vm.visioneConsenso.dataVisione | date:\'medium\'}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.fileFirma">File Firma</span></dt><dd><div ng-if="vm.visioneConsenso.fileFirma"><a ng-click="vm.openFile(vm.visioneConsenso.fileFirmaContentType, vm.visioneConsenso.fileFirma)" data-translate="entity.action.open">open</a> {{vm.visioneConsenso.fileFirmaContentType}}, {{vm.byteSize(vm.visioneConsenso.fileFirma)}}</div></dd><dt><span data-translate="consinfApp.visioneConsenso.fileFotoCartaceo">File Foto Cartaceo</span></dt><dd><div ng-if="vm.visioneConsenso.fileFotoCartaceo"><a ng-click="vm.openFile(vm.visioneConsenso.fileFotoCartaceoContentType, vm.visioneConsenso.fileFotoCartaceo)" data-translate="entity.action.open">open</a> {{vm.visioneConsenso.fileFotoCartaceoContentType}}, {{vm.byteSize(vm.visioneConsenso.fileFotoCartaceo)}}</div></dd><dt><span data-translate="consinfApp.visioneConsenso.fileVideoSelfie">File Video Selfie</span></dt><dd><div ng-if="vm.visioneConsenso.fileVideoSelfie"><a ng-click="vm.openFile(vm.visioneConsenso.fileVideoSelfieContentType, vm.visioneConsenso.fileVideoSelfie)" data-translate="entity.action.open">open</a> {{vm.visioneConsenso.fileVideoSelfieContentType}}, {{vm.byteSize(vm.visioneConsenso.fileVideoSelfie)}}</div></dd><dt><span data-translate="consinfApp.visioneConsenso.confermaHoCapito">Conferma Ho Capito</span></dt><dd><span>{{vm.visioneConsenso.confermaHoCapito}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.invioCedAttempts">Invio Ced Attempts</span></dt><dd><span>{{vm.visioneConsenso.invioCedAttempts}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.invioCedSuccess">Invio Ced Success</span></dt><dd><span>{{vm.visioneConsenso.invioCedSuccess}}</span></dd><dt><span data-translate="consinfApp.visioneConsenso.consInfUser">Cons Inf User</span></dt><dd><a ui-sref="cons-inf-user-detail({id:vm.visioneConsenso.consInfUser.id})">{{vm.visioneConsenso.consInfUser.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="visione-consenso-detail.edit({id:vm.visioneConsenso.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/visione-consenso/visione-consenso-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVisioneConsensoLabel" data-translate="consinfApp.visioneConsenso.home.createOrEditLabel">Create or edit a Visione Consenso</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.visioneConsenso.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.visioneConsenso.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.paziente" for="field_paziente">Paziente</label><input type="text" class="form-control" name="paziente" id="field_paziente" ng-model="vm.visioneConsenso.paziente" required><div ng-show="editForm.paziente.$invalid"><p class="help-block" ng-show="editForm.paziente.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.visioneConsenso.nome"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.emailMedicoDiBase" for="field_emailMedicoDiBase">Email Medico Di Base</label><input type="text" class="form-control" name="emailMedicoDiBase" id="field_emailMedicoDiBase" ng-model="vm.visioneConsenso.emailMedicoDiBase"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.emailFamiliare" for="field_emailFamiliare">Email Familiare</label><input type="text" class="form-control" name="emailFamiliare" id="field_emailFamiliare" ng-model="vm.visioneConsenso.emailFamiliare"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.dataVisione" for="field_dataVisione">Data Visione</label><div class="input-group"><input id="field_dataVisione" type="text" class="form-control" name="dataVisione" datetime-picker="{{dateformat}}" ng-model="vm.visioneConsenso.dataVisione" is-open="vm.datePickerOpenStatus.dataVisione"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataVisione\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group" ngf-drop ngf-change="vm.setFileFirma($file, vm.visioneConsenso)"><label class="control-label" data-translate="consinfApp.visioneConsenso.fileFirma" for="field_fileFirma">File Firma</label><div><div ng-if="vm.visioneConsenso.fileFirma" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.visioneConsenso.fileFirmaContentType, vm.visioneConsenso.fileFirma)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.visioneConsenso.fileFirmaContentType}}, {{vm.byteSize(vm.visioneConsenso.fileFirma)}}</span> <button type="button" ng-click="vm.visioneConsenso.fileFirma=null;vm.visioneConsenso.fileFirmaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileFirma($file, vm.visioneConsenso)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="fileFirma" id="field_fileFirma" ng-model="vm.visioneConsenso.fileFirma"> <input type="hidden" class="form-control" name="fileFirmaContentType" id="field_fileFirmaContentType" ng-model="vm.visioneConsenso.fileFirmaContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setFileFotoCartaceo($file, vm.visioneConsenso)"><label class="control-label" data-translate="consinfApp.visioneConsenso.fileFotoCartaceo" for="field_fileFotoCartaceo">File Foto Cartaceo</label><div><div ng-if="vm.visioneConsenso.fileFotoCartaceo" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.visioneConsenso.fileFotoCartaceoContentType, vm.visioneConsenso.fileFotoCartaceo)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.visioneConsenso.fileFotoCartaceoContentType}}, {{vm.byteSize(vm.visioneConsenso.fileFotoCartaceo)}}</span> <button type="button" ng-click="vm.visioneConsenso.fileFotoCartaceo=null;vm.visioneConsenso.fileFotoCartaceoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileFotoCartaceo($file, vm.visioneConsenso)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="fileFotoCartaceo" id="field_fileFotoCartaceo" ng-model="vm.visioneConsenso.fileFotoCartaceo"> <input type="hidden" class="form-control" name="fileFotoCartaceoContentType" id="field_fileFotoCartaceoContentType" ng-model="vm.visioneConsenso.fileFotoCartaceoContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setFileVideoSelfie($file, vm.visioneConsenso)"><label class="control-label" data-translate="consinfApp.visioneConsenso.fileVideoSelfie" for="field_fileVideoSelfie">File Video Selfie</label><div><div ng-if="vm.visioneConsenso.fileVideoSelfie" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.visioneConsenso.fileVideoSelfieContentType, vm.visioneConsenso.fileVideoSelfie)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.visioneConsenso.fileVideoSelfieContentType}}, {{vm.byteSize(vm.visioneConsenso.fileVideoSelfie)}}</span> <button type="button" ng-click="vm.visioneConsenso.fileVideoSelfie=null;vm.visioneConsenso.fileVideoSelfieContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileVideoSelfie($file, vm.visioneConsenso)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="fileVideoSelfie" id="field_fileVideoSelfie" ng-model="vm.visioneConsenso.fileVideoSelfie"> <input type="hidden" class="form-control" name="fileVideoSelfieContentType" id="field_fileVideoSelfieContentType" ng-model="vm.visioneConsenso.fileVideoSelfieContentType"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.confermaHoCapito" for="field_confermaHoCapito">Conferma Ho Capito</label><input type="checkbox" name="confermaHoCapito" id="field_confermaHoCapito" ng-model="vm.visioneConsenso.confermaHoCapito"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.invioCedAttempts" for="field_invioCedAttempts">Invio Ced Attempts</label><input type="number" class="form-control" name="invioCedAttempts" id="field_invioCedAttempts" ng-model="vm.visioneConsenso.invioCedAttempts"></div><div class="form-group"><label class="control-label" data-translate="consinfApp.visioneConsenso.invioCedSuccess" for="field_invioCedSuccess">Invio Ced Success</label><input type="checkbox" name="invioCedSuccess" id="field_invioCedSuccess" ng-model="vm.visioneConsenso.invioCedSuccess"></div><div class="form-group"><label data-translate="consinfApp.visioneConsenso.consInfUser" for="field_consInfUser">Cons Inf User</label><select class="form-control" id="field_consInfUser" name="consInfUser" ng-model="vm.visioneConsenso.consInfUser" ng-options="consInfUser as consInfUser.id for consInfUser in vm.consinfusers track by consInfUser.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/visione-consenso/visione-consensos.html','<div><h2 data-translate="consinfApp.visioneConsenso.home.title">Visione Consensos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="visione-consenso.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consinfApp.visioneConsenso.home.createLabel">Create new Visione Consenso</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paziente"><span data-translate="consinfApp.visioneConsenso.paziente">Paziente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="consinfApp.visioneConsenso.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailMedicoDiBase"><span data-translate="consinfApp.visioneConsenso.emailMedicoDiBase">Email Medico Di Base</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailFamiliare"><span data-translate="consinfApp.visioneConsenso.emailFamiliare">Email Familiare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataVisione"><span data-translate="consinfApp.visioneConsenso.dataVisione">Data Visione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileFirma"><span data-translate="consinfApp.visioneConsenso.fileFirma">File Firma</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileFotoCartaceo"><span data-translate="consinfApp.visioneConsenso.fileFotoCartaceo">File Foto Cartaceo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileVideoSelfie"><span data-translate="consinfApp.visioneConsenso.fileVideoSelfie">File Video Selfie</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confermaHoCapito"><span data-translate="consinfApp.visioneConsenso.confermaHoCapito">Conferma Ho Capito</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="invioCedAttempts"><span data-translate="consinfApp.visioneConsenso.invioCedAttempts">Invio Ced Attempts</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="invioCedSuccess"><span data-translate="consinfApp.visioneConsenso.invioCedSuccess">Invio Ced Success</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="consInfUser.id"><span data-translate="consinfApp.visioneConsenso.consInfUser">Cons Inf User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="visioneConsenso in vm.visioneConsensos track by visioneConsenso.id"><td><a ui-sref="visione-consenso-detail({id:visioneConsenso.id})">{{visioneConsenso.id}}</a></td><td>{{visioneConsenso.paziente}}</td><td>{{visioneConsenso.nome}}</td><td>{{visioneConsenso.emailMedicoDiBase}}</td><td>{{visioneConsenso.emailFamiliare}}</td><td>{{visioneConsenso.dataVisione | date:\'medium\'}}</td><td><a ng-if="visioneConsenso.fileFirma" ng-click="vm.openFile(visioneConsenso.fileFirmaContentType, visioneConsenso.fileFirma)" data-translate="entity.action.open">open</a> <span ng-if="visioneConsenso.fileFirma">{{visioneConsenso.fileFirmaContentType}}, {{vm.byteSize(visioneConsenso.fileFirma)}}</span></td><td><a ng-if="visioneConsenso.fileFotoCartaceo" ng-click="vm.openFile(visioneConsenso.fileFotoCartaceoContentType, visioneConsenso.fileFotoCartaceo)" data-translate="entity.action.open">open</a> <span ng-if="visioneConsenso.fileFotoCartaceo">{{visioneConsenso.fileFotoCartaceoContentType}}, {{vm.byteSize(visioneConsenso.fileFotoCartaceo)}}</span></td><td><a ng-if="visioneConsenso.fileVideoSelfie" ng-click="vm.openFile(visioneConsenso.fileVideoSelfieContentType, visioneConsenso.fileVideoSelfie)" data-translate="entity.action.open">open</a> <span ng-if="visioneConsenso.fileVideoSelfie">{{visioneConsenso.fileVideoSelfieContentType}}, {{vm.byteSize(visioneConsenso.fileVideoSelfie)}}</span></td><td>{{visioneConsenso.confermaHoCapito}}</td><td>{{visioneConsenso.invioCedAttempts}}</td><td>{{visioneConsenso.invioCedSuccess}}</td><td><a ui-sref="cons-inf-user-detail({id:visioneConsenso.consInfUser.id})">{{visioneConsenso.consInfUser.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="visione-consenso-detail({id:visioneConsenso.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="visione-consenso.edit({id:visioneConsenso.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="visione-consenso.delete({id:visioneConsenso.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-consinf.png" alt="logo"> <span data-translate="global.title">Consinf</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="cons-inf-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.consInfAccount">Cons Inf Account</span></a></li><li ui-sref-active="active"><a ui-sref="cons-inf-user" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.consInfUser">Cons Inf User</span></a></li><li ui-sref-active="active"><a ui-sref="visione-consenso" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.visioneConsenso">Visione Consenso</span></a></li><li ui-sref-active="active"><a ui-sref="oggetto-consenso" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.oggettoConsenso">Oggetto Consenso</span></a></li><li ui-sref-active="active"><a ui-sref="messaggio-voucher" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.messaggioVoucher">Messaggio Voucher</span></a></li><li ui-sref-active="active"><a ui-sref="video-informativo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.videoInformativo">Video Informativo</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li>\n--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();